import { PackType } from '../../../common/models/ItemModel';
import type { PriceCompareItem } from '../types/PriceCompareItem';

import { createPriceCompareItem } from './createPriceCompareItem';

export const updatePriceCompareItemPackType = (item: PriceCompareItem, packType?: string): PriceCompareItem => {
    const updatedItem = createPriceCompareItem(item);
    updatedItem.pack = Object.values(PackType).find((value) => value === packType) ?? PackType.BULK;
    updatedItem.compute();
    return updatedItem;
};
